// At the TOP of your file, outside all functions:
let teeInBlueCustomerChoseSize = false;

const enforceSizeSelection = () => {
  const atcButton = document.querySelector('#teeAtcButton');
  if (!atcButton) return;

  const sizeOption = document.querySelector('.tee-option--size:not(.sr-only)');
  if (!sizeOption) return;

  if (atcButton.dataset.forcedSizeInit === 'true') return;
  atcButton.dataset.forcedSizeInit = 'true';

  const PROMPT_TEXT = 'Select a Size to Continue';

  const getBtnSpan = (btn) =>
    btn.querySelector('span:not(.loading__spinner):not(.spinner)') || btn;
  const btnSpan = getBtnSpan(atcButton);
  const originalLabel = btnSpan.textContent.trim() || 'Add to Cart';

  const lock = () => {
    atcButton.disabled = true;
    atcButton.setAttribute('data-forced-disabled', 'true');
    btnSpan.textContent = PROMPT_TEXT;
  };

  const unlock = () => {
    atcButton.removeAttribute('data-forced-disabled');
    atcButton.disabled = false;
    btnSpan.textContent = originalLabel;
    document.body.classList.add('tib-size-chosen'); // add this line
  };

  if (!teeInBlueCustomerChoseSize) {
    lock();
  }


  // Document-level delegation — survives any re-render
  document.addEventListener('change', (e) => {
    const currentSizeOption = document.querySelector('.tee-option--size:not(.sr-only)');
    if (!currentSizeOption) return;
    if (currentSizeOption.contains(e.target) && e.target.matches('input[type="radio"]')) {
      teeInBlueCustomerChoseSize = true;
      unlock();
    }
  });

  // Re-lock only if size hasn't been chosen
  const observer = new MutationObserver(() => {
    if (!teeInBlueCustomerChoseSize && !atcButton.disabled) {
      lock();
    }
  });
  observer.observe(atcButton, { attributes: true });
};

/* PREVENT PEOPLE FROM ENTERING A CARRIAGE RETURN IN CUSTOMIZATION FIELDS - MESSES UP LAYOUT */
document.addEventListener('keydown', function(e) {
  if (e.key === 'Enter' && e.target.matches('input, textarea')) {
    e.preventDefault();
  }
});

const checkSizeChartButton = () => {
  const sizeOptionTitle = document.querySelector('.tee-option--size:not(.sr-only) .tee-option__title');

  if (!sizeOptionTitle) {
    console.log('Size option title not found yet');
    return;
  }
  
  // Check if we've already added the size chart link
  const existingLink = sizeOptionTitle.querySelector('.custom-size-chart-link');
  if (existingLink) {
    console.log('Size chart link already exists');
    return;
  }

  // Create the size chart link element
  const sizeChartLink = document.createElement('a');
  sizeChartLink.className = 'custom-size-chart-link';
  sizeChartLink.href = 'https://cdn.shopify.com/s/files/1/0964/9822/1366/files/size-chart-comfort-colors.webp?v=1774732639';
  sizeChartLink.target = '_blank';
  sizeChartLink.rel = 'noopener noreferrer';
  sizeChartLink.style.cssText = 'margin-left: 8px; vertical-align: middle; display: inline-flex; align-items: center; gap: 0.4em; text-decoration: none; color: inherit;';
  sizeChartLink.title = 'View Size Chart';
  
  // Add the popup behavior (opens in new window instead of tab)
  sizeChartLink.addEventListener('click', function(e) {
    e.preventDefault();
    e.stopPropagation();
    const width = 600;
    const height = 517;
    const left = (screen.width - width) / 2;
    const top = (screen.height - height) / 2;
    window.open(
      this.href, 
      'SizeChart', 
      `width=${width},height=${height},left=${left},top=${top},scrollbars=yes,resizable=yes`
    );
    return false;
  });
  
  // Create the icon image
  const icon = document.createElement('img');
  icon.src = 'https://cdn.shopify.com/s/files/1/0964/9822/1366/files/tape-measure.png?v=1774915589';
  icon.alt = 'Size Chart';
  icon.style.cssText = 'height: 2.0em; width: auto;';
  
  // Create the text span
  const text = document.createElement('span');
  text.textContent = 'Find your best fit • Sizes vary';
  
  // Assemble the link
  sizeChartLink.appendChild(icon);
  sizeChartLink.appendChild(text);
  
  // Add to the size option title
  sizeOptionTitle.appendChild(sizeChartLink);
  
  console.log('Size chart link added to TeeInBlue form');
}

// NEW FUNCTION: Add Loox review widget to TeeInBlue form
const addLooxReviewWidget = () => {
  const teeForm = document.querySelector('.tee-options');
  const looxWidget = document.querySelector('#shopify-block-AVVByZmw0ajg2TlowV__loox_reviews_loox_rating_wgkzaq');
  
  console.log('Checking for elements...', {teeForm, looxWidget});
  
  if (teeForm && looxWidget) {
    // Check if we've already added it
    const existingLoox = teeForm.querySelector('.teeinblue-loox-reviews');
    if (!existingLoox) {
      console.log('Adding Loox widget to TeeInBlue form');
      // Clone the Loox widget
      const looxClone = looxWidget.cloneNode(true);
      looxClone.classList.add('teeinblue-loox-reviews');
      
      // Insert at the very top of the form
      teeForm.insertBefore(looxClone, teeForm.firstChild);
    } else {
      console.log('Loox widget already exists in form');
    }
  } else {
    console.log('Elements not found yet');
  }
}

const moveConfirmationCheckbox = () => {
  const checkbox = document.querySelector('.tee-checkbox-wrapper');
  const atcButton = document.querySelector('#teeAtcButton');

  if (!checkbox || !atcButton) return;
  if (checkbox.classList.contains('confirm-moved')) return;
  checkbox.classList.add('confirm-moved');

  atcButton.parentNode.insertBefore(checkbox, atcButton);
};

function moveShippingNoticeBelowJustForYou() {
  const shippingNotice = document.querySelector('.shipping-notice-block');
  const priceBlock = document.querySelector('.tee-product-price');
  
  if (!shippingNotice || !priceBlock) return;

  // 1. Force the Price Block container to align left
  // We use !important because TeeInBlue styles can be very persistent
  priceBlock.style.setProperty('display', 'flex', 'important');
  priceBlock.style.setProperty('flex-direction', 'column', 'important');
  priceBlock.style.setProperty('align-items', 'flex-start', 'important');
  priceBlock.style.setProperty('text-align', 'left', 'important');
  priceBlock.style.setProperty('justify-content', 'flex-start', 'important');

  // 2. Ensure the shipping notice is inside the block
  if (shippingNotice.parentElement !== priceBlock) {
    priceBlock.appendChild(shippingNotice);
  }

  // 3. Force the individual elements within the block to align left
  // This targets the specific sub-elements to kill any inherited centering
  const priceSubElements = priceBlock.querySelectorAll('*');
  priceSubElements.forEach(el => {
    el.style.setProperty('margin-left', '0', 'important');
    el.style.setProperty('margin-right', 'auto', 'important');
    el.style.setProperty('text-align', 'left', 'important');
  });

  // 4. Specific styling for the Shipping Notice
  shippingNotice.style.cssText += `
    display: block !important;
    width: 100% !important;
    margin-top: 16px !important;
    order: 99 !important;
    text-align: left !important;
  `;
}

const moveShippingNoticeBelowPrice = () => {
  // 1. Updated Selector: The actual Shopify shipping/tax notice class
  const shippingNotice = document.querySelector('.product__tax.caption.rte');
  
  // 2. Updated Selector: The container for the message
  const priceMessage = document.querySelector('.tee-product-price-custom-info');
  
  // 3. The parent price block
  const priceBlock = document.querySelector('.tee-product-price');

  // NEW: Get the product title to check for "The Real"
  const productTitle = document.querySelector('h1')?.textContent?.trim() || "";
  const isRealCity = productTitle.startsWith("The Real");

  if (!shippingNotice || (!priceMessage && !priceBlock)) {
    return;
  }

  // NEW: Hide the specific text span if it's a "Real" product
  if (isRealCity && priceMessage) {
    //const textSpan = priceMessage.querySelector('span');
    // Target only the specific promotional span, avoiding the price element
    const textSpan = priceMessage.querySelector("span:not(.tee-price--current)");
    if (textSpan) {
      textSpan.style.display = 'none';
    }
  }

  // Prevent infinite loops
  if (shippingNotice.classList.contains('js-moved-to-price')) {
    return;
  }
  shippingNotice.classList.add('js-moved-to-price');

  if (priceMessage) {
    // Place it directly inside/after the "Made just for you" container
    priceMessage.appendChild(shippingNotice);
    console.log('Shipping notice moved below "Made just for you"');
  } else if (priceBlock) {
    priceBlock.appendChild(shippingNotice);
    console.log('Shipping notice moved to bottom of price block');
  }

  // Match the alignment
  shippingNotice.style.marginTop = '10px';
  shippingNotice.style.display = 'block';
};

// Function to move the estimate
const repositionDeliveryEstimate = () => {
  const estimate = document.querySelector('p.delivery-estimate');
  const shippingBlurb = document.querySelector('.product__tax.js-moved-to-price');
  
  if (estimate && shippingBlurb) {
    shippingBlurb.insertAdjacentElement('afterend', estimate);
    estimate.style.order = "10";
    estimate.style.display = 'block';
    estimate.style.marginTop = '4px';
  }
};


// Since teeinblue loads dynamically, you might need to run this after the form renders
repositionDeliveryEstimate();

// NEW FUNCTION: Move the Fitline block below TeeInBlue size options
const moveFitlineBelowSize = () => {
  // Your fitline block (the one you added via Custom Liquid)
  const fitline = document.querySelector('.ws-fitline');
  // TeeInBlue size option block
  const sizeOption = document.querySelector('.tee-option--size:not(.sr-only)');

  if (!fitline || !sizeOption) {
    console.log('Fitline or size option not found yet', { fitline, sizeOption });
    return;
  }

  // Avoid moving it multiple times
  if (fitline.classList.contains('fitline-moved')) {
    return;
  }
  fitline.classList.add('fitline-moved');

  // Insert directly AFTER the size option
  sizeOption.parentNode.insertBefore(fitline, sizeOption.nextSibling);

  console.log('Fitline moved below size options');
};

const movePriceBlock = () => {
  const priceBlock = document.querySelector('.tee-product-price');
  const sizeOption = document.querySelector('.tee-option--size:not(.sr-only)');
  
  if (!priceBlock || !sizeOption) return;

  // 1. Move the price block below sizes (if not already there)
  if (!priceBlock.classList.contains('price-moved')) {
    priceBlock.classList.add('price-moved');
    sizeOption.parentNode.insertBefore(priceBlock, sizeOption.nextSibling);
    console.log('Price block moved below size options');
  }

  // 2. CRITICAL: Re-trigger the shipping notice move 
  // This ensures that even if TeeInBlue resets the form, 
  // the notice gets pulled back into the price block immediately.
  //moveShippingNoticeBelowJustForYou();
  moveShippingNoticeBelowPrice();
  repositionDeliveryEstimate();
}

// Helper: find the closest ancestor that is a flex row (usually qty + atc live here)
const findClosestFlexRow = (el, maxHops = 8) => {
  let node = el;
  for (let i = 0; i < maxHops && node; i++) {
    node = node.parentElement;
    if (!node) break;

    const cs = window.getComputedStyle(node);
    const isFlex = cs.display === 'flex' || cs.display === 'inline-flex';
    if (!isFlex) continue;

    // Heuristic: flex row contains the ATC button and also some other control
    const hasAtc = node.querySelector && node.querySelector('#teeAtcButton');
    if (hasAtc) return node;
  }
  return null;
};

const moveSizeChartAccordionAboveATC = () => {
  const atcButton = document.querySelector('#teeAtcButton');
  if (!atcButton) return;

  // Find the accordion block whose title is "SIZING INFO"
  const accordionBlocks = Array.from(document.querySelectorAll('.product__accordion.accordion'));
  const sizeChartAccordion = accordionBlocks.find((block) => {
    const titleEl = block.querySelector('.accordion__title');
    return titleEl && titleEl.textContent.trim().toLowerCase() === 'sizing info';
  });

  if (!sizeChartAccordion) return;

  // Avoid moving multiple times
  if (sizeChartAccordion.classList.contains('sizechart-accordion-moved-atc')) return;
  sizeChartAccordion.classList.add('sizechart-accordion-moved-atc');

  // ✅ Insert ABOVE the whole ATC flex row (qty + button), not inside it
  const atcFlexRow = findClosestFlexRow(atcButton);
  const anchor = atcFlexRow || atcButton;

  anchor.parentNode.insertBefore(sizeChartAccordion, anchor);

  // Ensure it behaves like its own row
  sizeChartAccordion.style.display = 'block';
  sizeChartAccordion.style.width = '100%';
};

// Force Qty to its own row and make ATC full width (personalized tee UX)
const enforceFullWidthATCLayout = () => {
  const atcButton = document.querySelector('#teeAtcButton');
  if (!atcButton) return;

  // Reuse your existing flex-row finder if you have it already
  const findClosestFlexRow = (el, maxHops = 8) => {
    let node = el;
    for (let i = 0; i < maxHops && node; i++) {
      node = node.parentElement;
      if (!node) break;

      const cs = window.getComputedStyle(node);
      const isFlex = cs.display === 'flex' || cs.display === 'inline-flex';
      if (!isFlex) continue;

      const hasAtc = node.querySelector && node.querySelector('#teeAtcButton');
      if (hasAtc) return node;
    }
    return null;
  };

  const atcFlexRow = findClosestFlexRow(atcButton);
  if (!atcFlexRow) return;

  // Add a stable class so CSS can target it
  atcFlexRow.classList.add('ws-tib-atc-row');

  // Try to tag the quantity control too (best-effort)
  // This works for most qty steppers: buttons with +/-, input[type=number], etc.
  const qtyCandidate =
    atcFlexRow.querySelector('input[type="number"]') ||
    atcFlexRow.querySelector('[class*="quantity"]') ||
    atcFlexRow.querySelector('button[aria-label*="increase" i]')?.closest('div') ||
    atcFlexRow.querySelector('button[aria-label*="decrease" i]')?.closest('div');

  if (qtyCandidate) qtyCandidate.classList.add('ws-tib-qty');

  // Also tag the button itself
  atcButton.classList.add('ws-tib-atc-button');
};


// NEW FUNCTION: Add sizing message above Add to Cart button
const addSizingMessage = () => {
  const atcButton = document.querySelector('#teeAtcButton');
  
  if (!atcButton) {
    console.log('Add to Cart button not found yet');
    return;
  }
  
  // Check if message already added
  const existingMessage = document.querySelector('.size-chart-reminder-tee');
  if (existingMessage) {
    console.log('Sizing message already exists');
    return;
  }
  
  // Create the sizing message
  const sizingMessage = document.createElement('p');
  sizingMessage.className = 'size-chart-reminder-tee';
  sizingMessage.innerHTML = '⚠️ All shirts are made to order. Please review the <b>size chart</b> before ordering. We do not offer returns or exchanges for sizing issues.';
  atcButton.parentNode.insertBefore(sizingMessage, atcButton);
  
  console.log('Sizing message added above Add to Cart button');
}

// NEW FUNCTION: Add/update color selection display
const updateColorDisplay = () => {
  const colorContainer = document.querySelector('.tee-option--color');
  if (!colorContainer) return;
  
  // Hide the original COLOR title
  const titleElement = colorContainer.querySelector('.tee-option__title');
  if (titleElement) {
    titleElement.style.display = 'none';
  }
  
  // Find the selected color
  const selectedInput = colorContainer.querySelector('input[type="radio"]:checked');
  if (!selectedInput) return;
  
  const colorName = selectedInput.value;
  
  // Check if display already exists
  let colorDisplay = colorContainer.querySelector('.tee-color-display');
  
  if (!colorDisplay) {
    // Create the display element
    colorDisplay = document.createElement('div');
    colorDisplay.className = 'tee-color-display';
    // Match the styling from your image - bold, uppercase, with spacing
    colorDisplay.style.cssText = 'margin-bottom: 12px; font-weight: 500; color: #333; text-transform: uppercase; font-size: 0.8rem; letter-spacing: 0.05em;';
    
    // Insert at the top of the color container
    colorContainer.prepend(colorDisplay);
  }
  
  // Update the text - showing "COLOR: Color Name"
  colorDisplay.textContent = `COLOR: ${colorName}`;
  console.log(`Updated color display to: ${colorName}`);
}


// ─── CONFIG ────────────────────────────────────────────────────────────────────
const BLANK_CONFIG = {
  'Vintage Wash Tee': {  // Comfort Colors — match the span text exactly
    sizeChartUrl: 'https://cdn.shopify.com/s/files/1/0964/9822/1366/files/size-chart-comfort-colors.webp?v=1774732639',
    whyLoveIt: `<ul>
      <li>Garment-dyed heavyweight tee with a soft broken-in feel.</li>
      <li>Relaxed fit that looks even better slightly oversized.</li>
      <li>Vintage-inspired wash gives every shirt authentic character.</li>
      <li>Designed to feel less like merch and more like a favorite old tee.</li>
    </ul>`,
    moreThanJustShirt: `<p>
  The landmarks may belong to the postcards.
  <br><br>
But the real city belongs to the people who live there.
<br><br>
Whether it’s Crown Heights, Harlem, Bushwick, or somewhere only locals understand, this shirt is about wearing the part of the city that actually feels like home.
</p>`,
   details: `<ul>
      <li>Comfort Colors 1717 heavyweight garment-dyed tee.</li>
      <li>6.1 oz, 100% ring-spun cotton with a lived-in feel.</li>
      <li>Relaxed unisex fit with a vintage washed finish.</li>
      <li>Soft-washed and garment-dyed for extra comfort and reduced shrinkage.</li>
      <li>Printed to order in the USA with responsibly sourced materials.</li>
    </ul>`
  },
  'Classic Fit Tee': {  // Bella Canvas — match the span text exactly
    sizeChartUrl: 'https://cdn.shopify.com/s/files/1/0964/9822/1366/files/Bella-3001-size-chart.jpg?v=1779727461',
    whyLoveIt: `<ul>
      <li>Clean retail fit that feels modern without being too slim.</li>
      <li>Lightweight, ultra-soft fabric that works year-round.</li>
      <li>Designed to turn hometown pride into something you’d actually want to wear.</li>
      <li>A more elevated take on the classic graphic tee.</li>
    </ul>`,
    moreThanJustShirt: `<p>
  This isn’t about the version of the city tourists see.
  <br><br>
It’s about the neighborhood that shaped you, raised you, or became part of your story.
<br><br>
The Real City Collection was designed for locals, transplants, and anyone who knows there’s always a deeper version of a place.</p>`,
   details: `<ul>
      <li>Bella+Canvas 3001 retail fit tee.</li>
      <li>Lightweight 100% Airlume combed and ring-spun cotton.</li>
      <li>Soft feel with a clean modern silhouette.</li>
      <li>Unisex fit with a slightly tailored shape.</li>
      <li>Printed to order in the USA with responsibly sourced materials.</li>
    </ul>`
  }
};

// ───────────────────────────────────────────────────────────────────────────────

/* Apply config based on shirt blank: Bella+Canvas 3001 or Comfort Colors 1717 ("blank" refers to shirt type) */
const applyBlankConfig = () => {

  const isComfortColors = window.productTags?.includes('comfort-colors');
  const isBellaCanvas = window.productTags?.includes('bella-canvas');
  
  let blankName = "Vintage Wash Tee";
  if (isBellaCanvas) {
    blankName = "Classic Fit Tee";
  }
  
  if (!blankName) return;

  const config = BLANK_CONFIG[blankName];
  if (!config) {
    console.log(`No config found for blank: "${blankName}"`);
    return;
  }

  console.log(`Applying config for: ${blankName}`);

  // 1. Swap size chart URL on the existing link
  const sizeChartLink = document.querySelector('.custom-size-chart-link');
  if (sizeChartLink) {
    sizeChartLink.href = config.sizeChartUrl;
    // Also update the popup click handler's URL
    sizeChartLink._blankSizeChartUrl = config.sizeChartUrl;
  }

  // 2. Swap "Why People Love It" accordion content
  const accordionBlocks = Array.from(document.querySelectorAll('.product__accordion.accordion'));
  const whyLoveItAccordion = accordionBlocks.find((block) => {
    const titleEl = block.querySelector('.accordion__title');
    return titleEl && titleEl.textContent.trim().toLowerCase() === 'why people love it';
  });

  if (whyLoveItAccordion) {
    const contentEl = whyLoveItAccordion.querySelector('.accordion__content.rte');
    if (contentEl) {
      contentEl.innerHTML = config.whyLoveIt;
    }
  }

 // 3. Swap "More than just a shirt" accordion content
 // const accordionBlocks = Array.from(document.querySelectorAll('.product__accordion.accordion'));
  const moreThanJustShirtAccordion = accordionBlocks.find((block) => {
    const titleEl = block.querySelector('.accordion__title');
    return titleEl && titleEl.textContent.trim().toLowerCase() === 'more than just a shirt';
  });

  if (moreThanJustShirtAccordion) {
    const contentEl = moreThanJustShirtAccordion.querySelector('.accordion__content.rte');
    if (contentEl) {
      contentEl.innerHTML = config.moreThanJustShirt;
    }
  }

 // 4. Swap "Details" accordion content
 // const accordionBlocks = Array.from(document.querySelectorAll('.product__accordion.accordion'));
  const detailsAccordion = accordionBlocks.find((block) => {
    const titleEl = block.querySelector('.accordion__title');
    return titleEl && titleEl.textContent.trim().toLowerCase() === 'details';
  });

  if (detailsAccordion) {
    const contentEl = detailsAccordion.querySelector('.accordion__content.rte');
    if (contentEl) {
      contentEl.innerHTML = config.details;
    }
  }
};

// NEW FUNCTION: Replace color pills with swatches
const replaceColorPillsWithSwatches = () => {
  // Only apply swatches on desktop (screen width > 768px)
  if (window.innerWidth <= 768) {
    console.log('Mobile detected - skipping color swatch conversion');
    return;
  }
  
  const colorRadios = document.querySelectorAll('.tee-option--color .tee-radio--color');
  
  if (colorRadios.length === 0) {
    console.log('No color radios found yet');
    return;
  }
  
  // Color mapping from your theme settings
  const colorMap = {
    'Bay': '#94a596',
    'Ivory': '#e7ceb5',
    'Pepper': '#4e4b48',
    'Sage': '#3e4827',
    'Yam': '#be531c',
    'Blue Jean': '#647692',
    'Crimson': '#8d3842',
    'True Navy': '#041e42',
    'Berry': '#7e4966',
    'Blossom': '#f8bed6',
    'Moss': '#6b7c5e',
    'Espresso': '#715a4e',
    'Chalky Mint': '#82bfbb',
    'Navy': '#1f2a44',
    'Black': '#211e16',
    'Asphalt': '#6c6864',
    'Ash': '#e8e9ed',
    'Mauve': '#a36d6a',
    'Blue Spruce': '#3e5d58',
    'Brick': '#aa4a5c'
  };
  
  console.log('Replacing color pills with swatches...');
  
  colorRadios.forEach(radio => {
    // Check if already converted
    if (radio.classList.contains('swatch-converted')) {
      return;
    }
    
    const input = radio.querySelector('input[type="radio"]');
    const label = radio.querySelector('label');
    const span = label ? label.querySelector('span') : null;
    
    if (!input || !label || !span) return;
    
    const colorName = input.value;
    const hexColor = colorMap[colorName];
    
    if (hexColor) {
      // Add converted class to prevent re-processing
      radio.classList.add('swatch-converted');
      
      // Store the hex color as a data attribute so CSS can use it
      label.setAttribute('data-swatch-color', hexColor);
      
      // Apply swatch styling - force square dimensions with !important
      const size = '34px';
      label.style.setProperty('width', size, 'important');
      label.style.setProperty('height', size, 'important');
      label.style.setProperty('min-width', size, 'important');
      label.style.setProperty('min-height', size, 'important');
      label.style.setProperty('max-width', size, 'important');
      label.style.setProperty('max-height', size, 'important');
      label.style.setProperty('flex', 'none', 'important');
      label.style.borderRadius = '100%';
      label.style.border = 'none';
      label.style.position = 'relative';
      label.style.cursor = 'pointer';
      label.style.display = 'block';
      label.style.margin = '0';
      label.style.padding = '0';
      
      // Force transparent background using setProperty with !important
      label.style.setProperty('background-color', 'transparent', 'important');
      label.style.setProperty('background', 'transparent', 'important');
      
      // Hide the text span
      span.style.display = 'none';
      span.classList.add('visually-hidden');
      
      // Add pseudo-element styling for borders (via class)
      label.classList.add('color-swatch-tee');
      
      // Add change event listener to update color display
      input.addEventListener('change', () => {
        updateColorDisplay();
      });
      
      // Set up a MutationObserver to watch for style changes on this label
      let observerTimeout;
      const labelObserver = new MutationObserver((mutations) => {
        // Debounce to reduce processing
        clearTimeout(observerTimeout);
        observerTimeout = setTimeout(() => {
          // Keep label at 34px always
          const targetSize = '34px';
          
          // Only update if actually different
          if (label.style.width !== targetSize || label.style.height !== targetSize) {
            label.style.setProperty('width', targetSize, 'important');
            label.style.setProperty('height', targetSize, 'important');
            label.style.setProperty('min-width', targetSize, 'important');
            label.style.setProperty('min-height', targetSize, 'important');
            label.style.setProperty('max-width', targetSize, 'important');
            label.style.setProperty('max-height', targetSize, 'important');
          }
          if (label.style.backgroundColor !== 'transparent') {
            label.style.setProperty('background-color', 'transparent', 'important');
            label.style.setProperty('background', 'transparent', 'important');
          }
        }, 10);
      });
      
      // Start observing the label for attribute changes
      labelObserver.observe(label, {
        attributes: true,
        attributeFilter: ['style']
      });
      
      // Add touch/click handler with debouncing
      let clickTimeout;
      const handleInteraction = () => {
        clearTimeout(clickTimeout);
        clickTimeout = setTimeout(() => {
          label.style.setProperty('width', '34px', 'important');
          label.style.setProperty('height', '34px', 'important');
          label.style.setProperty('flex', 'none', 'important');
        }, 50);
      };
      
      radio.addEventListener('click', handleInteraction, { passive: true });
      radio.addEventListener('touchend', handleInteraction, { passive: true });
      
      console.log(`Converted ${colorName} to swatch with color ${hexColor}`);
    }
  });
  
  // After converting swatches, update the color display
  updateColorDisplay();
}

// Use MutationObserver to watch for when elements are added to the page
const observeForElements = () => {
  let debounceTimer;
  
  const observer = new MutationObserver((mutations) => {
    // Debounce to avoid running too frequently
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      // Check if TeeInBlue form exists
      const teeForm = document.querySelector('.tee-options');
      const looxWidget = document.querySelector('#shopify-block-AVVByZmw0ajg2TlowV__loox_reviews_loox_rating_wgkzaq');
      
      if (teeForm && looxWidget) {
        addLooxReviewWidget();
      }
      
      // Check for size chart
      checkSizeChartButton();
      
      // Move price block below sizes
      movePriceBlock();

      moveFitlineBelowSize();

      moveShippingNoticeBelowPrice();
      repositionDeliveryEstimate();
      //moveShippingNoticeBelowJustForYou();
      
      // Replace color pills with swatches - run immediately for color changes
      replaceColorPillsWithSwatches();
      
      // Add sizing message (re-add if missing)
    //  addSizingMessage();
      moveSizeChartAccordionAboveATC();

      // TEST
      enforceSizeSelection();

      enforceFullWidthATCLayout();
      moveConfirmationCheckbox();

    //  applyBlankConfig();
      
    }, 50); // Reduced from 100ms to 50ms for faster response
  });

  // Start observing the document with configured parameters
  observer.observe(document.body, {
    childList: true,
    subtree: true
  });
  
  // Direct listener for blank switching — add once at the bottom of observeForElements
  //document.addEventListener('change', (e) => {
    //if (e.target.matches('.tee-available-products input[type="radio"]')) {
      // Small delay to let TeeInBlue update the .active class
      //setTimeout(applyBlankConfig, 100);
    //}
  //});

  console.log('MutationObserver started watching for TeeInBlue and Loox elements');
}

// Start observing when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', observeForElements);
} else {
  observeForElements();
}

// Also try with the original TeeInBlue events (in case they do fire)
document.addEventListener("teeinblue-event-variant-changed", () => {
  console.log('TeeInBlue variant changed event fired');
  
  // Immediately re-apply swatches without delay
  replaceColorPillsWithSwatches();
  
  const checkElementRendered = setInterval(() => {
    const sizeTitle = document.querySelector('.tee-option--size:not(.sr-only) .tee-option__title');
    if (sizeTitle) {
      checkSizeChartButton();
      clearInterval(checkElementRendered);
    }
  }, 200);
  
  addLooxReviewWidget();
  //addSizingMessage();
  movePriceBlock();
  moveShippingNoticeBelowPrice();
  repositionDeliveryEstimate();
  //moveShippingNoticeBelowJustForYou();
  moveFitlineBelowSize();
  moveSizeChartAccordionAboveATC();
  // TEST
  enforceSizeSelection();
  enforceFullWidthATCLayout();
  moveConfirmationCheckbox();
  //applyBlankConfig();

});

document.addEventListener("teeinblue-event-component-injected", () => {
  console.log('TeeInBlue component injected event fired');
  
  // Immediately re-apply swatches without delay
  replaceColorPillsWithSwatches();
  
  const checkElementRendered = setInterval(() => {
    const sizeTitle = document.querySelector('.tee-option--size:not(.sr-only) .tee-option__title');
    if (sizeTitle) {
      checkSizeChartButton();
      clearInterval(checkElementRendered);
    }
  }, 200);
  
  addLooxReviewWidget();
  //addSizingMessage();
  movePriceBlock();
  moveFitlineBelowSize();
  moveSizeChartAccordionAboveATC();
  // TEST
  enforceSizeSelection();
  enforceFullWidthATCLayout();
  moveConfirmationCheckbox();
  //applyBlankConfig();
})
